/** The eleven services, in display order (three menu groups: recruitment, assessment and role profile, HR advisory). HRLabs is never the employer. */
export const SERVICES = [
    {
        key: 'recruitment', group: 'g1',
        slug: { en: 'recruitment', bg: 'podbor-na-personal' },
        name: { en: 'Recruitment', bg: 'Подбор на персонал' },
        desc: {
            en: 'We find and assess candidates; you employ the person you choose',
            bg: 'Намираме и оценяваме кандидати; вие наемате избрания човек',
        },
    },
    {
        key: 'executive-search', group: 'g1',
        slug: { en: 'executive-search', bg: 'podbor-rakovodni-kadri' },
        name: { en: 'Executive search', bg: 'Подбор на ръководни кадри' },
        desc: {
            en: 'Discreet search for leaders, including people who are not looking',
            bg: 'Дискретно търсене на ръководители, включително хора, които не търсят работа',
        },
    },
    {
        key: 'freelance-interim', group: 'g1',
        slug: { en: 'freelance-interim', bg: 'frilansari-i-proektni-specialisti' },
        name: { en: 'Freelance and interim recruitment', bg: 'Подбор на фрийлансъри и проектни специалисти' },
        desc: {
            en: 'Contractors and interim specialists for a defined period',
            bg: 'Контрактори и interim специалисти за определен период',
        },
    },
    {
        key: 'rpo', group: 'g1',
        slug: { en: 'rpo', bg: 'rpo' },
        name: { en: 'RPO / embedded recruitment', bg: 'RPO / вграден подбор' },
        desc: {
            en: 'We take over all or part of your recruitment process',
            bg: 'Поемаме целия ваш процес по подбор или част от него',
        },
    },
    {
        key: 'assessment', group: 'g2',
        slug: { en: 'assessment', bg: 'ocenka-na-kandidati' },
        name: { en: 'Candidate assessment', bg: 'Оценка на кандидати' },
        desc: {
            en: 'Assessment of candidates you have already found',
            bg: 'Оценка на кандидати, които вече сте намерили',
        },
    },
    {
        key: 'reference-checks', group: 'g2',
        slug: { en: 'reference-checks', bg: 'proverka-na-preporaki' },
        name: { en: 'Reference and background checks', bg: 'Проверка на препоръки и професионална биография' },
        desc: {
            en: 'We verify CV claims and gather references',
            bg: 'Проверяваме данните в автобиографията и събираме отзиви',
        },
    },
    {
        key: 'job-descriptions', group: 'g2',
        slug: { en: 'job-descriptions', bg: 'dlazhnostni-harakteristiki' },
        name: { en: 'Job descriptions and role profiles', bg: 'Изготвяне на длъжностни характеристики и профили' },
        desc: {
            en: 'We define exactly what you need, before the search starts',
            bg: 'Описваме точно какво търсите, преди да започне търсенето',
        },
    },
    {
        key: 'salary-benchmarking', group: 'g3',
        slug: { en: 'salary-benchmarking', bg: 'konsultacii-i-benchmarking-na-zaplati' },
        name: { en: 'Salary consulting and benchmarking', bg: 'Консултации и бенчмаркинг на възнагражденията' },
        desc: {
            en: 'What the market pays for the specific role',
            bg: 'Какво плаща пазарът за конкретната позиция',
        },
    },
    {
        key: 'employer-branding', group: 'g3',
        slug: { en: 'employer-branding', bg: 'rabotodatelska-marka' },
        name: { en: 'Employer branding', bg: 'Работодателска марка' },
        desc: {
            en: 'Careers messaging candidates believe',
            bg: 'Кариерни послания, на които кандидатите вярват',
        },
    },
    {
        key: 'onboarding', group: 'g3',
        slug: { en: 'onboarding', bg: 'onbording' },
        name: { en: 'Onboarding support', bg: 'Онбординг' },
        desc: {
            en: 'Support for settling new employees in',
            bg: 'Подкрепа при въвеждането на новите служители',
        },
    },
    {
        key: 'outplacement', group: 'g3',
        slug: { en: 'outplacement', bg: 'autpleysmant' },
        name: { en: 'Outplacement', bg: 'Аутплейсмънт' },
        desc: {
            en: 'Support for people leaving and for the managers who tell them',
            bg: 'Подкрепа за напускащите и за ръководителите, които им съобщават',
        },
    },
];
export const SERVICE_GROUPS = ['g1', 'g2', 'g3'];
export function serviceBySlug(slug, lang) {
    return SERVICES.find((s) => s.slug[lang] === slug);
}
export function serviceByKey(key) {
    return SERVICES.find((s) => s.key === key);
}
//# sourceMappingURL=serviceCatalog.js.map